import { Inspect } from '../../../../components/Inspect'
import {
  formatReviewString,
  replacePhraseWithString,
  reviewHhsPrograms
} from '../../../../utilities'

export const InspectFWA = ({ goBackToPage, pages, values }) => {
  const allegation_choices = require('../../../../choices/json/FWA_allegation.json')
  const allegationDetails = [
    {
      heading: 'Allegation type',
      field_name: 'allegation',
      value: formatReviewString(
        replacePhraseWithString(
          [allegation_choices[values.allegation]],
          values.allegation_other
        ).join(', ')
      )
    }
  ].concat(reviewHhsPrograms(values))

  return Inspect({ goBackToPage, pages, values, allegationDetails })
}
